import { Container, Row, Col, Button, Form } from "react-bootstrap";
import "../../../App.css";
import "../../../css/bootstrap.scss";

import Header from "../../Includes/Header";
import { useNavigate, useParams } from "react-router-dom";
import React, { useState, useEffect } from "react";
import countriesStateData from "../../../data/states.json";
import { toHaveFormValues } from "@testing-library/jest-dom/matchers";
import { Field, reduxForm, InjectedFormProps } from "redux-form";
import { connect } from "react-redux";
import {
  setwizardPageNumber,
  setCertificationDetails,
  setwizardPageName,
} from "../../EntityAccountReducer";
import { RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { updateEntityKycDraftStep } from "../../../Utils/entityKycDraft";
import { useTranslation } from "react-i18next";

interface Props {}

interface FormData {
  certification1: boolean;
  certification2: boolean;
  certificationNotes: string;
}

const renderCheckbox = ({ input, label, meta }: any) => (
  <div className="mb-2">
    <Form.Check
      {...input}
      type="checkbox"
      checked={input.value}
      className={`text-secondary ${meta.touched && meta.error ? "reg-checkbox border-danger" : ""}`}
      label={<span className="form-check-label text-secondary">{label}</span>}
    />
    {meta.touched && meta.error && (
      <p className="text-danger small mt-1 ps-2 mb-0 fw-bold">{meta.error}</p>
    )}
  </div>
);

const CertificationForm: React.FC<
  Props & InjectedFormProps<{}, Props, FormData>
> = (props: any) => {
  const { handleSubmit } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const page = useSelector(
    (state: RootState) => state.entityAccount.wizardPageNumber
  );

  const userID = useSelector((state: RootState) => state.entityAccount.userID);

  useEffect(() => {
    dispatch(setwizardPageName("certification"));
  }, [dispatch]);

  const submitForm = async (formValues: FormData) => {
    try {
      await updateEntityKycDraftStep(userID, 'certification', formValues);
      dispatch(setCertificationDetails(formValues));
      dispatch(setwizardPageNumber(7));
      localStorage.setItem('pageNumber', '7');
    } catch (error) {
      console.error("Failed to save certification:", error);
    }
  };

  return (
    <>
      <div className="pt-0 pb-3 mb-5 col-md-11 mx-auto px-2">
        <Row className="justify-content-center">
          <Col md={11}>
            <p className=" fw-bold  d-inline">{t('kyc.entity_account_app')}</p>
            <p className="text-warning d-inline ms-3 small">{t('common.in_progress')}</p>
            <h4 className="mt-5 letter-spacing-fix fw-medium">{t('kyc.entity_nav_certification')}</h4>
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col md={11}>
            <Form noValidate={true} onSubmit={handleSubmit(submitForm)}>
              <Row className="mt-4 mb-3">
                <Col md={12}>
                  <label className="form-label  letter-spacing-fix">
                    {t('kyc.cert_please_certify')}
                  </label>
                  <div className="row">
                    <div className="col-md-12 mt-2">
                      <Field
                        name="certification1"
                        component={renderCheckbox}
                        label={t('kyc.cert1_text')}
                      />
                      <Field
                        name="certification2"
                        component={renderCheckbox}
                        label={t('kyc.cert2_text')}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="mb-3 mt-4">
                <Col md={12}>
                  <Row className="row mb-2">
                    <Col md={11}>
                      <label className="form-label letter-spacing-fix ">
                        {t('kyc.cert_notes_label')}
                      </label>
                    </Col>
                    <Col md={1}>
                      <p className="text-warning  small ">{t('kyc.optional')}</p>
                    </Col>
                  </Row>
                </Col>

                <Col md={12}>
                  <Field
                    name="certificationNotes"
                    component="textarea"
                    className="form-control rounded-4 h-auto"
                    rows={3}
                    placeholder={t('kyc.cert_notes_ph')}
                  />
                </Col>
              </Row>

              <Row className="mt-3 mb-1">
                <Col md={12}>
                  <Button
                    type="submit"
                    className="btn btn-secondary rounded-5  mt-2"
                    style={{ background: "#0B1628" }}
                  >
                    {t('common.save_continue')}
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </div>
    </>
  );
};

const validate = (values: FormData) => {
  const errors: any = {};
  if (!values.certification1) {
    errors.certification1 = "Please certify to continue";
  }
  if (!values.certification2) {
    errors.certification2 = "Please authorize to continue";
  }
  return errors;
};

const mapStateToProps = (state: RootState) => ({
  initialValues: state.entityAccount.certificationDetails,
});

const form = reduxForm<{}, Props, FormData>({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  form: "certificationForm",
  enableReinitialize: true,
  validate,
})(CertificationForm);

export default connect(mapStateToProps)(form);
